import { Box, styled, Typography } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { Trans } from 'react-i18next';

import { TextLines } from 'core/elements';
import { NumberHelper } from 'core/helpers';
import { getAgGridTableCellData } from 'core/utils';
import { PartListColId } from 'elements/components/PartList/enums';
import { IComponentTemplate } from 'elements/types';

const ContentWrapper = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  gap: '4px',
});

const ValueWrapper = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral[900],
  fontSize: 12,
}));

export const PackagingCell = (props: ICellRendererParams<IComponentTemplate>) => {
  const data = getAgGridTableCellData(props, PartListColId.PACKAGING);

  if (!data) {
    return props?.value;
  }

  const { packageUnits, manufacturerMinimumQuantity, orderIncrement, uom } = data;

  const contentWrapper = <ContentWrapper />;
  const valueWrapper = <ValueWrapper />;

  const packValue = (
    <Trans
      i18nKey="labelPackWithValue"
      components={{ contentWrapper, valueWrapper }}
      values={{
        value: NumberHelper.formatIntegerPerUom(packageUnits, uom),
      }}
    />
  );

  const moqValue = (
    <Trans
      i18nKey="labelMoqWithValue"
      components={{ contentWrapper, valueWrapper }}
      values={{
        value: NumberHelper.formatIntegerPerUom(manufacturerMinimumQuantity, uom),
      }}
    />
  );

  const incrValue = (
    <Trans
      i18nKey="labelIncrWithValue"
      components={{ contentWrapper, valueWrapper }}
      values={{
        value: NumberHelper.formatIntegerPerUom(orderIncrement, uom),
      }}
    />
  );

  return <TextLines texts={[packValue, moqValue, incrValue]} isSubText />;
};
